import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { EditorMobileFooter } from 'builder/components/PreviewPanel'

export const DesktopDesignContent = styled.div`
  padding-top: 12px;
  margin-top: 4px;
  background-color: ${Colors.White};
  border-radius: 12px;
`

export const MobileDesignContent = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  width: 100vw;
`

export const FooterActions = styled(EditorMobileFooter)`
  z-index: 4;
`
